import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { isString, debounce, includes, uniqBy } from 'lodash';
import ChargersInfo from '../../resources/ChargersInfo';
import TextField from '../TextField/TextField';
import Autocomplete from '../Autocomplete/Autocomplete';

const OptionWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: 140%;
  padding: 5px 0;

  .value {
    font-size: 12px;
    color: #999;
  }
`;

const CHARGERS_AMOUNT_REQUEST = 1;
const CHARGERS_AMOUNT_SHOWING = 10;

function ChargerCombobox(props) {
  const {
    label,
    name,
    required,
    style,
    onChange,
    defaultValue,
    error,
    errorText,
    helperText,
    plazaId,
    excludedChargers,
    includedChargers,
  } = props;

  const [options, setOptions] = useState([]);
  const [conditionOptions, setConditionOptions] = useState([]);

  const [search, setSearch] = useState('');

  useEffect(() => {
    ChargersInfo.shortDescription(
      { page: -1, size: CHARGERS_AMOUNT_REQUEST },
      {
        filterBy: {
          query: search,
          linked_to_plaza: false,
          excluded_conditions: ['INACTIVE', 'PENDING'],
          plaza_uuid: plazaId,
        },
      },
      true,
    ).then(({ data: { payloads } }) => {
      setOptions(payloads.map((charger) => ({ label: charger.name, value: charger.uuid })));
    });
  }, [search]);

  useEffect(() => {
    const allOptions = uniqBy([...options, ...includedChargers], 'value');

    if (excludedChargers && excludedChargers.length) {
      setConditionOptions(allOptions.filter((option) => !includes(excludedChargers, option.value)).slice(0, CHARGERS_AMOUNT_SHOWING));
    } else {
      setConditionOptions(allOptions.slice(0, CHARGERS_AMOUNT_SHOWING));
    }
  }, [options, excludedChargers]);

  const changeSearch = debounce((search) => setSearch(search), 800);

  const filterOptions = (options, { inputValue }) => {
    if (!inputValue) return options;

    return options.filter(({ value, label }) => value.indexOf(inputValue) !== -1 || label.indexOf(inputValue) !== -1);
  };

  return (
    <Autocomplete
      defaultValue={defaultValue}
      onChange={onChange}
      style={style}
      options={conditionOptions}
      getOptionLabel={(option) => option.value || ''}
      filterOptions={filterOptions}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <OptionWrap>
            <span className="value">{option.value}</span>
            <span className="label">{option.label}</span>
          </OptionWrap>
        </li>
      )}
      onInputChange={(e, value) => changeSearch(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          name={name}
          required={required}
          error={error}
          helperText={isString(errorText) ? errorText : helperText}
        />
      )}
    />
  );
}

export default ChargerCombobox;
